import type { Identifier } from 'react-admin';
import type { ShopScanResource } from '../../Entities/ShopScan';
import { Flag } from '../../utils';

export const SCAN_STATUS_CHOICES = [
  { id: 0, name: 'Generating' },
  { id: 1, name: 'Active' },
  { id: 2, name: 'Completed' },
  { id: 3, name: 'Terminated' },
];

export const SHOP_SCAN_STATUS_FLAGS: Flag[] = [
  { id: 0, name: 'Running', color: 'primary' },
  { id: 1, name: 'Success', color: 'success' },
  { id: 2, name: 'Unsuccessful', color: 'warning' },
  { id: 4, name: 'Mapping Errors', color: 'warning' },
  { id: 8, name: 'Feed Errors', color: 'error' },
  { id: 16, name: 'Critical Error', color: 'error' },
];

export function hasShopScanMappingErrors(record?: ShopScanResource): boolean {
  const status = record?.attributes?.status ?? 0;

  return (status & 4) > 0;
}

export function getShopScanMappingErrorPath(
  record?: ShopScanResource,
  fallbackMerchantId?: Identifier,
): string | false {
  if (!hasShopScanMappingErrors(record)) return false;

  const scanId = record?.relationships?.scan?.data?.id;
  const merchantId = record?.relationships?.merchant?.data?.id ?? fallbackMerchantId;

  return scanId == null || merchantId == null ? false : `/mapping_errors/${scanId}/${merchantId}`;
}

export function getShopScanMappingErrorRowSx(record?: ShopScanResource) {
  const cursor = hasShopScanMappingErrors(record) ? 'pointer' : 'default';

  return {
    '&:hover': {
      cursor,
    },
    cursor,
  };
}

export const FIELD_CHOICES = [
  { id: 0, name: 'Index_Url' },
  { id: 1, name: 'Index_Category' },
  { id: 100, name: 'Url' },
  { id: 101, name: 'ExternalID' },
  { id: 102, name: 'Name' },
  { id: 103, name: 'Manufacturer' },
  { id: 104, name: 'Mpn' },
  { id: 105, name: 'Gtin' },
  { id: 106, name: 'Category' },
  { id: 107, name: 'Price' },
  { id: 108, name: 'RegPrice' },
  { id: 109, name: 'ShipmentPrice' },
  { id: 110, name: 'ImageUrl' },
  { id: 111, name: 'Description' },
  { id: 112, name: 'Model' },
  { id: 113, name: 'IsValid' },
  { id: 114, name: 'Stock' },
];
